export const FramePaths = {
  RoundOne: {
    width: 524,
    height: 349,
    path:
      "M156.025 343.955L54.024 317.212l-49-80.775 9.001-117.748 45.999-87.467 86.001-19.648 141.001-6.55 143.207 13.694 75.795 71.449 12.52 130.988-40.092 87.325-92.429 34.908-230.002.567z",
  },
  RoundTopLeft: {
    width: 947,
    height: 709,
    path:
      "M2.062 706.062l9.067-147.741 9.068-161.622 18.135-190.378 26.194-80.315 64.479-78.333L241.844 19.91l164.22-17.848h537.998v704H3.069Z",
  },
  RoundTopOne: {
    width: 361,
    height: 213,
    path:
      "M 356.2 160.87 344.68 99.64 322.84 50.07 275.55 22.55 177.63 0.5 79.7 6.33 43.7 22.55 0.5 128.8 0.5 213.36 360.52 213.36 356.2 160.87z",
  },
  RoundTopTwo: {
    width: 362,
    height: 212,
    path:
      "M 346.44 37.53 304.41 12.94 184.2 0.51 85.86 22.37 36.7 36.08 16.45 86.69 4.88 159.58 0.54 211.64 362.07 211.64 362.07 127.76 346.44 37.53z",
  },
  RoundTopThree: {
    width: 361,
    height: 213,
    path:
      "M 356.2 160.87 344.68 99.64 322.84 50.07 275.55 22.55 177.63 0.5 79.7 6.33 43.7 22.55 0.5 128.8 0.5 213.36 360.52 213.36 356.2 160.87z",
  },
  RoundTopFour: {
    width: 362,
    height: 212,
    path:
      "M 346.44 37.53 304.41 12.94 184.2 0.51 85.86 22.37 36.7 36.08 16.45 86.69 4.88 159.58 0.54 211.64 362.07 211.64 362.07 127.76 346.44 37.53z",
  },
  RoundTopFive: {
    width: 361,
    height: 213,
    path:
      "M 356.2 160.87 344.68 99.64 322.84 50.07 275.55 22.55 177.63 0.5 79.7 6.33 43.7 22.55 0.5 128.8 0.5 213.36 360.52 213.36 356.2 160.87z",
  },
  RoundTopSix: {
    width: 362,
    height: 212,
    path:
      "M 346.44 37.53 304.41 12.94 184.2 0.51 85.86 22.37 36.7 36.08 16.45 86.69 4.88 159.58 0.54 211.64 362.07 211.64 362.07 127.76 346.44 37.53z",
  },
};
